export class Media {
    constructor(url: string, alt: string){
        this.url = url;
        this.alt = alt;
    }
    url: string;
    alt: string;
}